import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MITIGATION_MODES, MITIGATION_MODE_OPTIONS } from '@ids-constants';
import { BaseComponent } from '@ids-components';
import { SelectButtonModule } from 'primeng/selectbutton';
import { FormsModule } from '@angular/forms';
import { MitigationWorkflowComponent } from './mitigation-workflow/mitigation-workflow.component';
import { MitigationRecommendationComponent } from './mitigation-recommendation/mitigation-recommendation.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-shared-mitigations',
  templateUrl: './shared-mitigations.component.html',
  styleUrls: ['./shared-mitigations.component.scss'],
  imports: [CommonModule, FormsModule, SelectButtonModule, MitigationWorkflowComponent, MitigationRecommendationComponent],
})
export class SharedMitigationsComponent extends BaseComponent implements OnInit, OnDestroy {
  /* Threat Details */

  @Input() threat = null;

  @Input() threatGroup = null;

  /* Mode of selectButton: Workflow or Recommend */

  mode: string = MITIGATION_MODES.WORKFLOW;

  /* Constants */

  MITIGATION_MODES = MITIGATION_MODES;

  MITIGATION_MODE_OPTIONS = MITIGATION_MODE_OPTIONS;

  constructor() {
    super();
  }

  ngOnInit() {
    this.prepareConfigs();
  }
}
